"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimString = exports.trimStringRight = exports.trimStringLeft = void 0;
const trimStringLeft = (source, remove = ' ') => {
    let result = source;
    while (result.startsWith(remove)) {
        result = result.substring(remove.length);
    }
    return result;
};
exports.trimStringLeft = trimStringLeft;
const trimStringRight = (source, remove = ' ') => {
    let result = source;
    while (result.endsWith(remove)) {
        result = result.substring(0, result.length - remove.length);
    }
    return result;
};
exports.trimStringRight = trimStringRight;
const trimString = (source, remove = ' ') => {
    return ((0, exports.trimStringLeft)((0, exports.trimStringRight)(source, remove), remove));
};
exports.trimString = trimString;
